import React from 'react';
import PropTypes from 'prop-types';

const EasySplit = ({ fill = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.585 1.95752H11.835C11.7442 1.95849 11.6557 1.98602 11.5804 2.03671C11.505 2.0874 11.4462 2.15904 11.4111 2.24278C11.376 2.32652 11.3662 2.4187 11.3829 2.50795C11.3996 2.5972 11.442 2.67961 11.505 2.74502L12.75 3.97502L9.26251 7.50002L10.5 8.73752L14.025 5.25002L15.255 6.48002C15.3204 6.543 15.4028 6.58545 15.4921 6.60213C15.5813 6.61882 15.6735 6.60901 15.7572 6.57392C15.841 6.53883 15.9126 6.47999 15.9633 6.40466C16.014 6.32933 16.0415 6.24081 16.0425 6.15002V2.41502C16.0406 2.29429 15.9918 2.17904 15.9064 2.09366C15.821 2.00827 15.7057 1.95945 15.585 1.95752ZM14.025 12.75L8.85001 8.10002H2.85001C2.7316 8.09796 2.614 8.11988 2.50429 8.16448C2.39458 8.20907 2.29503 8.27541 2.21164 8.3595C2.12825 8.44359 2.06274 8.54369 2.01907 8.65377C1.97539 8.76385 1.95445 8.88163 1.95751 9.00002C1.95751 9.23275 2.04996 9.45594 2.21452 9.62051C2.37908 9.78507 2.60228 9.87752 2.83501 9.87752H7.97251L12.75 14.025L11.52 15.255C11.457 15.3204 11.4146 15.4028 11.3979 15.4921C11.3812 15.5813 11.391 15.6735 11.4261 15.7573C11.4612 15.841 11.52 15.9126 11.5954 15.9633C11.6707 16.014 11.7592 16.0416 11.85 16.0425H15.6C15.7207 16.0406 15.836 15.9918 15.9214 15.9064C16.0068 15.821 16.0556 15.7058 16.0575 15.585V11.835C16.0565 11.7442 16.029 11.6557 15.9783 11.5804C15.9276 11.5051 15.856 11.4462 15.7722 11.4111C15.6885 11.376 15.5963 11.3662 15.5071 11.3829C15.4178 11.3996 15.3354 11.442 15.27 11.505L14.025 12.75Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
  </svg>
);

EasySplit.propTypes = {
  fill: PropTypes.string,
};

export default EasySplit;
